"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var trixPrefixSize = 5;
// Define this object with .ixx and .ix files.
// Then use the trixSearch() function to search for a word.
var Trix = /** @class */ (function () {
    /**
     * @param ixxFile [anyFile] the second-level trix index file produced by ixIxx.
     * @param ixFile [anyFile] the first-level trix index file produced by ixIxx.
     * @param maxResults [number] the maximum number of results to return. Default is set to 20.
     */
    function Trix(ixxFile, ixFile, maxResults) {
        if (maxResults === void 0) { maxResults = 20; }
        this.index = this._parseIxx(ixxFile);
        this.ixFile = ixFile;
        this.maxResults = maxResults;
    }
    /**
     * Search trix for the given searchWord(s). Return up to {this.maxResults} results.
     * This method matches each index prefix against each searchWord. It does not do fuzzy matching.
     *
     * @param searchString [string] term(s) separated by spaces to search for id(s).
     * @returns results [Array<string>] where each string is a corresponding itemId.
     */
    Trix.prototype.search = function (searchString) {
        return __awaiter(this, void 0, void 0, function () {
            var resultArr, firstWord, initialSet, searchWords, w, searchWord, bufData, buf, bufPos, resultSet, linePtr, numValues, startsWith, done, i, tempBufData, cur, line, arr, arr_1, arr_1_1, hit;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        resultArr = [];
                        firstWord = true;
                        initialSet = new Set();
                        searchWords = searchString.split(' ');
                        w = 0;
                        _b.label = 1;
                    case 1:
                        if (!(w < searchWords.length)) return [3 /*break*/, 10];
                        searchWord = searchWords[w];
                        searchWord = searchWord.toLowerCase();
                        return [4 /*yield*/, this._getBuffer(searchWord)];
                    case 2:
                        bufData = _b.sent();
                        buf = bufData.buf;
                        bufPos = bufData.bufEndPos;
                        resultSet = new Set();
                        linePtr = 0;
                        numValues = 0;
                        _b.label = 3;
                    case 3:
                        if (!(linePtr < buf.byteLength)) return [3 /*break*/, 8];
                        startsWith = true;
                        done = false;
                        i = linePtr;
                        _b.label = 4;
                    case 4:
                        if (!(buf[i] != 10)) return [3 /*break*/, 7];
                        if (!(i >= buf.byteLength)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._getNextChunk(bufPos)];
                    case 5:
                        tempBufData = _b.sent();
                        if (tempBufData) {
                            buf = tempBufData.buf;
                            bufPos = tempBufData.bufEndPos;
                            i = 0;
                            linePtr = 0;
                        }
                        else {
                            // If tempBufData is null, we reached the end of the file, so we are done.
                            done = true;
                            return [3 /*break*/, 7];
                        }
                        _b.label = 6;
                    case 6:
                        if (startsWith) {
                            cur = String.fromCharCode(buf[i]);
                            if (i < linePtr + searchWord.length &&
                                searchWord[i - linePtr] > cur) {
                                // searchWord[i] > cur, so keep looping.
                                startsWith = false;
                            }
                            else if (i < linePtr + searchWord.length &&
                                searchWord[i - linePtr] < cur) {
                                // searchWord[i] < cur, so we lexicographically will not find any more results.
                                startsWith = false;
                                done = true;
                                return [3 /*break*/, 7];
                            }
                            else {
                                // This condition indicates we found a match.
                                if (buf[i] === 44) {
                                    // We found a ',' so increment numValues by one.
                                    numValues++;
                                    // If we're searching for one word and we have enough results, break out at the next space.
                                    if (numValues >= this.maxResults && searchWords.length === 1) {
                                        while (buf[i] != 32)
                                            i++;
                                        return [3 /*break*/, 7];
                                    }
                                }
                            }
                        }
                        i++;
                        return [3 /*break*/, 4];
                    case 7:
                        if (done)
                            return [3 /*break*/, 8];
                        // If the line starts with the searchWord, we have a hit!
                        if (startsWith) {
                            line = buf.slice(linePtr, i).toString();
                            arr = this._parseHitString(line);
                            if (searchWords.length === 1) {
                                // Only a single search word so add results to array.
                                resultArr = resultArr.concat(arr);
                                // Once we have enough results, stop searching.
                                if (resultArr.length >= this.maxResults)
                                    return [3 /*break*/, 8];
                            }
                            else {
                                try {
                                    // Handle multiple words using sets.
                                    for (arr_1 = (e_1 = void 0, __values(arr)), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                                        hit = arr_1_1.value;
                                        hit = hit.toLowerCase();
                                        if (firstWord) {
                                            resultSet.add(hit);
                                        }
                                        else {
                                            if (initialSet.has(hit)) {
                                                resultSet.add(hit);
                                                // If it is on the last iteration of words, break after we reach maxResults
                                                if (w === searchWords.length - 1 &&
                                                    resultSet.size >= this.maxResults)
                                                    break;
                                            }
                                        }
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                            }
                        }
                        linePtr = i + 1;
                        return [3 /*break*/, 3];
                    case 8:
                        initialSet = resultSet;
                        firstWord = false;
                        // If there aren't any results, stop looping, because an intersection with an empty set is an empty set.
                        if (resultArr.length === 0 && initialSet.size === 0)
                            return [2 /*return*/, []];
                        _b.label = 9;
                    case 9:
                        w++;
                        return [3 /*break*/, 1];
                    case 10:
                        // 4. Return the hitList [list of string]
                        if (searchWords.length === 1) {
                            return [2 /*return*/, resultArr];
                        }
                        // Else we need to return our set converted to an array
                        resultArr = Array.from(initialSet);
                        if (resultArr.length > this.maxResults)
                            return [2 /*return*/, resultArr.slice(0, this.maxResults)];
                        return [2 /*return*/, resultArr];
                }
            });
        });
    };
    // Private Methods:
    /**
     * Seek ahead to the correct position in the .ix file,
     * then load that chunk of .ix into a buffer.
     *
     * @param searchWord [string]
     * @returns a Buffer holding the sections we want to search.
     */
    Trix.prototype._getBuffer = function (searchWord) {
        return __awaiter(this, void 0, void 0, function () {
            var seekPosStart, seekPosEnd, indexes, indexes_1, indexes_1_1, _a, key, value, trimmedKey;
            var e_2, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        seekPosStart = 0;
                        seekPosEnd = -1;
                        return [4 /*yield*/, this.index];
                    case 1:
                        indexes = _c.sent();
                        try {
                            for (indexes_1 = __values(indexes), indexes_1_1 = indexes_1.next(); !indexes_1_1.done; indexes_1_1 = indexes_1.next()) {
                                _a = __read(indexes_1_1.value, 2), key = _a[0], value = _a[1];
                                trimmedKey = key.slice(0, searchWord.length);
                                if (seekPosEnd === -1) {
                                    if (trimmedKey >= searchWord) {
                                        // We reached the end pos in the file.
                                        seekPosEnd = value - 1;
                                        break;
                                    }
                                    else {
                                        seekPosStart = value;
                                    }
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (indexes_1_1 && !indexes_1_1.done && (_b = indexes_1.return)) _b.call(indexes_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        // Return the buffer and its end position in the file.
                        return [2 /*return*/, this._createBuffer(seekPosStart, seekPosEnd)];
                }
            });
        });
    };
    /**
     * Given the end position of the last buffer,
     * load the next chunk  of .ix data into a buffer and return it.
     *
     * @param seekPosStart [number] where to start loading data into the new buffer.
     * @returns a Buffer holding the chunk we want to search.
     */
    Trix.prototype._getNextChunk = function (seekPosStart) {
        return __awaiter(this, void 0, void 0, function () {
            var seekPosEnd, indexes, indexes_2, indexes_2_1, _a, key, value;
            var e_3, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (seekPosStart == -1)
                            return [2 /*return*/, null];
                        seekPosEnd = -1;
                        return [4 /*yield*/, this.index];
                    case 1:
                        indexes = _c.sent();
                        try {
                            for (indexes_2 = __values(indexes), indexes_2_1 = indexes_2.next(); !indexes_2_1.done; indexes_2_1 = indexes_2.next()) {
                                _a = __read(indexes_2_1.value, 2), key = _a[0], value = _a[1];
                                if (value <= seekPosStart + 1)
                                    continue;
                                seekPosEnd = value;
                                break;
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (indexes_2_1 && !indexes_2_1.done && (_b = indexes_2.return)) _b.call(indexes_2);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        seekPosStart--;
                        // Return the buffer and its end position in the file.
                        return [2 /*return*/, this._createBuffer(seekPosStart, seekPosEnd)];
                }
            });
        });
    };
    /**
     * Create and return a buffer given the start and end position
     * of what to load from the .ix file.
     *
     * @param seekPosStart [number] byte the buffer should start reading from file.
     * @param seekPosEnd [number] byte the buffer should stop reading from file.
     * @returns a Buffer holding the chunk of data.
     */
    Trix.prototype._createBuffer = function (seekPosStart, seekPosEnd) {
        return __awaiter(this, void 0, void 0, function () {
            var bufLength, stat, buf;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(seekPosEnd < 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.ixFile.stat()];
                    case 1:
                        stat = _a.sent();
                        bufLength = stat.size - seekPosStart;
                        return [3 /*break*/, 3];
                    case 2:
                        bufLength = seekPosEnd - seekPosStart;
                        _a.label = 3;
                    case 3:
                        buf = Buffer.alloc(bufLength);
                        return [4 /*yield*/, this.ixFile.read(buf, 0, bufLength, seekPosStart)];
                    case 4:
                        _a.sent();
                        // Return the buffer and its end position in the file.
                        return [2 /*return*/, { buf: buf, bufEndPos: seekPosEnd }];
                }
            });
        });
    };
    /**
     * Takes in a hit string and returns an array of result terms.
     *
     * @param line [string] The line of .ix that is a hit.
     * @returns results [Array<hit>]. Each hit contains the itemId [string], and wordPos [number].
     */
    Trix.prototype._parseHitString = function (line) {
        var e_4, _a;
        var arr = [];
        var _b = __read(line.split(' ')), term = _b[0], parts = _b.slice(1); // skip term
        try {
            // Each result is of format: "{itemId},{wordPos}"
            // Parse the entire line of these and return
            for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                var part = parts_1_1.value;
                var pair = part.split(',');
                if (pair.length === 2) {
                    var itemId = pair[0];
                    var wordPos = Number.parseInt(pair[1]);
                    if (typeof wordPos !== 'number' || isNaN(wordPos))
                        throw new Error("Error in ix index format at term " + itemId + " for word " + parts[0]);
                    arr.push(term + "," + itemId);
                }
                else if (pair.length > 1) {
                    throw new Error("Error in ix index format at word " + parts[0]);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return arr;
    };
    /**
     * Parses ixx file and constructs a map of {word: ixFileLocation}
     *
     * @param ixxFile [anyFile] second level index that is produced by ixIxx.
     * @returns a ParsedIxx map.
     */
    Trix.prototype._parseIxx = function (ixxFile) {
        return __awaiter(this, void 0, void 0, function () {
            var file, lines;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ixxFile.readFile('utf8')];
                    case 1:
                        file = (_a.sent());
                        lines = file.split('\n');
                        return [2 /*return*/, new Map(lines
                                .filter(function (f) { return !!f; })
                                .map(function (line) {
                                var prefix = line.substr(0, trixPrefixSize);
                                var posStr = line.substr(trixPrefixSize);
                                var pos = Number.parseInt(posStr, 16);
                                return [prefix, pos];
                            }))];
                }
            });
        });
    };
    return Trix;
}());
exports.default = Trix;
